export default __webpack_public_path__ + "static/media/190629_190332_IMG_4107 (1).aaf284e9.jpg";